import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, take, map } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Dialog } from 'primeng/dialog';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { EditorModule } from '@tinymce/tinymce-angular';
import { AbstractControl, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';

import * as fromNews from 'src/app/_store/_reducers';
import { OnDestroyMixin } from 'src/app/_shared/classes/component-destroy.class';
import { News } from 'src/app/_shared/interface/news.interface';
import { NewsActions } from 'src/app/_store/_news/actions';
import * as fromStore from 'src/app/_store/_reducers';
import { WhatsNewFeature } from 'src/app/_shared/classes/features';
import { EditorDirective } from 'src/app/_shared/editor/editor.directive';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-release-news',
  templateUrl: './release-news.component.html',
  styleUrls: ['./release-news.component.scss'],
  imports: [
    MatIconButton,
    MatTooltip,
    MatIcon,
    FormsModule,
    ReactiveFormsModule,
    EditorModule,
    EditorDirective,
    MatButton,
    AsyncPipe,
    TranslateModule,
    Dialog,
    ButtonModule,
  ],
})
export class ReleaseNewsComponent extends OnDestroyMixin implements OnDestroy, OnInit {
  @ViewChild('dialogContainer', { static: false }) dialogContainer: ElementRef;

  @Input()
  set showDialog(value: boolean) {
    this.internalShowDialog = value;
  }
  @Output() showDialogChange = new EventEmitter<boolean>();
  releaseText: string;
  editorConfig = {
    height: 300,
    menubar: false,
    image_uploadtab: true,
    image_list: null,
    file_picker_types: 'image',
    image_dimensions: true,
    plugins: 'lists link image table code',
    toolbar:
      'undo redo | blocks | bold italic underline strikethrough | alignleft aligncenter alignright | bullist numlist outdent indent | image | fullscreen',
    block_formats: 'Paragraph=p;Heading 1=h1;Heading 2=h2;Heading 3=h3',
  };
  news$: Observable<News>;
  newsForm: FormGroup;
  editNewsMode: boolean = false;
  addNewsMode: boolean = false;
  whatsNewFeatureFlag$: Observable<WhatsNewFeature>;
  internalShowDialog;

  constructor(private store: Store<fromNews.State>) {
    super();
    this.news$ = this.store.select<News>(fromNews.getNews);
    this.whatsNewFeatureFlag$ = this.store.select(fromStore.getFeatureHeader).pipe(
      take(1),
      map((headerFeatureFlag) => headerFeatureFlag?.whatsNew)
    );
  }

  ngOnInit(): void {
    const newsInformation = this.releaseText || '';
    this.newsForm = new FormGroup({
      newsInformation: new FormControl(newsInformation, [Validators.required]),
    });
  }

  public get newsInformation(): AbstractControl {
    return this.newsForm.get('newsInformation');
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  onClose(): void {
    this.store.dispatch(NewsActions.closeNews());
    this.internalShowDialog = false;
    this.showDialogChange.emit(false);
  }

  closeDialog(): void {
    this.store.dispatch(NewsActions.closeNews());
    this.internalShowDialog = false;
    this.showDialogChange.emit(false);
  }

  onEdit(addNews: boolean): void {
    this.editNewsMode = true;
    this.addNewsMode = addNews;
    this.news$.pipe(take(1)).subscribe((news) => {
      this.newsInformation.setValue(news.content);
      this.newsForm.markAsPristine();
    });
  }

  onCancel(): void {
    this.editNewsMode = false;
  }

  onSubmit(): void {
    if (this.addNewsMode) {
      this.store.dispatch(NewsActions.addNews({ payload: { content: this.newsInformation.value } }));
    } else {
      this.store.dispatch(NewsActions.setNews({ payload: { content: this.newsInformation.value } }));
    }
    this.editNewsMode = false;
  }

  onDialogShow(): void {
    setTimeout(() => {
      if (this.dialogContainer?.nativeElement) {
        this.dialogContainer.nativeElement.scrollTop = 0;
      }
    }, 100);
  }
}
